import { useEffect, useState } from "react";
import {
  Step,
  StepDescription,
  StepIcon,
  StepIndicator,
  StepNumber,
  StepStatus,
  StepTitle,
  Stepper,
  useSteps,
  Box,
  StepSeparator,
} from "@chakra-ui/react";
import { MdClose } from "react-icons/md";

interface IProps {
  transferStatus: string;
  paymentStatus: string;
  orientation: "horizontal" | "vertical";
  reason?: string;
  isMobile?: boolean;
}
const PaymentStatusStepper = ({ paymentStatus, transferStatus, orientation, reason, isMobile }: IProps) => {
  const [steps, setSteps] = useState([
    { title: "Payment Made", description: `You have initiated payment` },
    { title: "Payment Received", description: `We are confirming your payment` },
    { title: "Transfer Pending", description: `Transfer has not started` },
  ]);

  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });

  const failedStatus = transferStatus === "TransferFailed" || transferStatus === "TransferCancelled";
  useEffect(() => {
    if (paymentStatus === "PaymentMade") {
      setActiveStep(1);
    }

    if (paymentStatus === "PaymentConfirmed") {
      setActiveStep(2);
    }

    if (transferStatus === "TransferComplete") {
      setActiveStep(3);

      setSteps((prevSteps) => {
        const pStep = [...prevSteps];

        const updatedStep = {
          title: "Transfer Complete",
          description: "Transfer has been completed",
        };

        pStep[2] = updatedStep;

        return pStep;
      });
    }

    if (paymentStatus === "PaymentConfirmed") {
      setSteps((prevSteps) => {
        const pStep = [...prevSteps];

        const updatedStep = {
          title: "Payment Received",
          description: "Transfer will start soon",
          // description: "We have received your payment",
        };

        pStep[1] = updatedStep;

        return pStep;
      });
    }

    if (failedStatus) {
      setSteps((prevSteps) => {
        const pStep = [...prevSteps];

        const updatedStep = {
          title: "Transfer Failed",
          description: reason ? reason : "Transfer could not be completed",
        };

        pStep[2] = updatedStep;

        return pStep;
      });
    }
  }, [paymentStatus, transferStatus, setActiveStep, failedStatus, reason]);

  return (
    <>
      <Stepper
        index={activeStep}
        orientation={orientation}
        mt={{ base: "48px", md: "0" }}
        width="100%"
        height="300px"
        gap="0"
        colorScheme="primary"
      >
        {steps.map(({ description, title }, index) => (
          <Step key={index}>
            <StepIndicator border={failedStatus && index === 2 ? "1px solid #ED1C00 !important" : "1px solid #3AC1A1"}>
              <StepStatus
                complete={<StepIcon />}
                incomplete={<StepNumber />}
                active={failedStatus ? <MdClose fontSize="20px" fontWeight="700" color="#ED1C00" /> : <StepNumber />}
              />
            </StepIndicator>

            <Box flexShrink="0">
              <StepTitle>{title}</StepTitle>
              <StepDescription>{description}</StepDescription>
            </Box>

            <StepSeparator
              className="seperator"
              style={{
                background: failedStatus && index === 1 ? "#ED1C00" : "#3AC1A1",
              }}
            />
          </Step>
        ))}
      </Stepper>
    </>
  );
};

export default PaymentStatusStepper;
